<template>
  <div id="main-wrapper">
      <!-- Page Preloader -->
      <div id="preloader">
        <div id="status">
          <div class="status-mes"></div>
        </div>
      </div>

      <div class="columns-block">
        <LeftCol />
        <RightCol />
          <!-- .right-col-block -->
        </div>
        <!-- .columns-block -->
      </div>
      <!-- #main-wrapper -->
</template>

<script>

import LeftCol from './left-col'
import RightCol from './right-col'

export default {
  name: 'app',
  components: {
    LeftCol,
    RightCol
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

/* Impresion / PDF: el curriculum en A4, sin menus ni adornos */
@media print {
  @page { size: A4; margin: 12mm; }
  html, body { background: #fff !important; }
  #preloader, .social-icon, .profile-img, .print-button, .portfolio-section, footer, .footer, #contact, .contact-section { display: none !important; }
  .columns-block, .left-col-block, .right-col-block, .blocks { position: static !important; float: none !important; width: 100% !important; height: auto !important; margin: 0 !important; padding: 0 !important; }
  .left-col-block .header { background: none !important; color: #000 !important; padding: 0 0 8px !important; min-height: 0 !important; }
  .left-col-block h1, .left-col-block h2, .left-col-block .lead { color: #000 !important; }
  .section-wrapper, .timeline-item, .expertise-item { break-inside: avoid; page-break-inside: avoid; }
  .section-title h2, .section-title h3 { break-after: avoid; }
  a { color: #000 !important; text-decoration: none !important; }
}
</style>
